module.exports = __webpack_public_path__ + "img/dotdotdot.12ef31f1.svg";